import { gql } from '@apollo/client';

const deleteEndService = gql`
  mutation deleteEndService($_id: String) {
    deleteEndService(_id: $_id) {
      ok
      message
      error
    }
  }
`;

export default deleteEndService;
